var map = {
	"./": 685,
	"./en": 620,
	"./en.js": 620,
	"./fr": 691,
	"./fr.js": 691,
	"./index": 685,
	"./index.js": 685,
	"./sp": 223,
	"./sp.js": 223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 985;